/** @format */

import {Box} from '@mui/material';

import CustomInfo from './CustomInfo';
import IdText from './IdText';

const Keyword = props => {
  const sample = props.reportItemGroup[0];
  const showCustomInfo = sample.maxLocationField === 'keywordId';

  return (
    <Box display='flex' flexDirection='column'>
      <IdText id={sample.keywordId} text={sample.keyword} />

      {showCustomInfo && (
        <CustomInfo reportItemGroup={props.reportItemGroup} sensorName={props.sensorName} />
      )}
    </Box>
  );
};

export default Keyword;
